<template>
<div class="integral-shop">
  <list-page-header
    :car-info="carInfo"
    ref="pageheader"
    @sort-change="sortChange"
    @open-shopcar="openShopcar"
    @location-click="locationClick"
    class="list-page-header"
  ></list-page-header>
  <div
    class="content pc-padding30-mobil-padding20"
    v-loading="loading"
  >
    <el-row :gutter="20">
      <el-col
        :lg="6"
        :md="12"
        :sm="12"
        :xs="24"
        v-for="(item,index) in list"
        :key="index"
      >
        <shop-item
          :shop-item="item"
          @add-car-success="addCarSuccess"
        ></shop-item>
      </el-col>
    </el-row>
  </div>
  <shop-car
    ref="shopcar"
    @close="closeHandle"
    :dialog-show="carDialogShow"
    @send-car-data="sendCarData"
    @settlehandle="settlehandle"
    @send-quantity="acceptQuantity"
  ></shop-car>
  <sure-order
    :car-info="carInfo"
    :settle-product-arr="settleProductArr"
    @close="closeOrderDialogHandle"
    @edit-address="editAddressHandle"
    @exchange-success="exchangeSuccess"
    :dialog-show="sureOrderDialogShow"
  ></sure-order>
  <shipping-address
    :address-info="carInfo.shippingInfo"
    :dialog-show="addressDialogShow"
    @close="closeAddressDialogHandle"
    @add-or-edit-success="addOrEditSuccess"
  ></shipping-address>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import shippingAddress from '@/components/integralShop/dialog/shippingAddress';
import sureOrder from '@/components/integralShop/dialog/sureOrder';
import shopCar from '@/components/integralShop/dialog/shopCar';
import { queryProcutList } from '@/api/userCenter'
import shopItem from '@/components/integralShop/shopItem';
import listPageHeader from '@/components/integralShop/listPageHeader';
export default {
  name: 'index',
  components:{
    listPageHeader,
    shopItem,
    shopCar,
    sureOrder,
    shippingAddress,
  },
  data() {
    return {
      loading: false,
      list: null,
      totalSize: 0,
      size: 8,
      page: 0,
      // 加载更多
      ajaxIng: false,
      //购物车:
      carDialogShow: false ,
      sureOrderDialogShow: false ,
      carInfo: {
        shippingInfo: {
          "name": "",
          "nationCode": "+86",
          "phone": "",
          "city": "",
          "detailedAddress": "",
        },
        cartSize: 0,
      }, // 购物车信息,包含积分和购物车商品列表和购物车商品数量
      addressDialogShow: false,
      settleProductArr: [],
    };
  },
  created(){
    if(this.language == 'en_US'){
      this.$router.push({name: 'userCenterPerson'});
    }
  },
  mounted(){
    if(this.language == 'en_US'){
      this.$router.push({name: 'dashboard'})
    }
    this.getList();
    let reouterview = document.getElementById('routerview');
    if(!reouterview) return;
    reouterview.classList.add('no-padding-import');
  },
  beforeDestroy() {
    let reouterview = document.getElementById('routerview');
    if(reouterview){
      reouterview.classList.remove('no-padding-import');
    }
  },
  computed: {
    ...mapGetters(['language']),
  },
  methods: {
    settlehandle(settleProductArr){
      this.settleProductArr = settleProductArr;
      this.sureOrderDialogShow = true;
    },
    sendCarData(res){
      this.carInfo = res;
    },
    getList(){
      let params = {
        // page: this.page,
        // size: this.size,
        type: this.$refs.pageheader.sort,
      }
      queryProcutList(params).then((res) => {
        this.loading = false;
        this.list = res.data;
        /*if(res.data.totalElements){
          this.totalSize = res.data.totalElements;
        }*/
      }).catch((error) => {
        this.loading = false;
      })
    },
    // 加载更多
    scrollBottom () {

      if(this.ajaxIng == true){
        return;
      }
      if(this.list == null) return;
      if(this.list.length >= this.totalSize) {
        return;
      }
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if ((scrollTop + windowHeight ) >= (scrollHeight - 50 )) {
        this.page++;
        let params = {
          page: this.page,
          size: this.size,
        };
        this.loading = true;
        this.ajaxIng = true;
        queryProcutList(params).then((res) => {
          this.loading = false;
          // this.list = this.list.concat(res.data.content);
          this.list = this.list.concat(JSON.parse(JSON.stringify(this.listSettimeout)));
          /*if(res.data.totalElements){
            this.totalSize = res.data.totalElements;
          };*/
          this.ajaxIng = false;
        }).catch((error) => {
          this.loading = false;
          this.ajaxIng = false;
        })
      }
    },
    sortChange(){
      this.page = 0;
      this.totalSize = 50;
      this.getList();
    },
    closeHandle(){
      this.carDialogShow = false;
    },
    closeOrderDialogHandle(){
      this.sureOrderDialogShow = false;
    },
    openShopcar(){
      this.carDialogShow = true
    },

    // 确认订单弹框地址编辑,
    editAddressHandle(){
      this.addressDialogShow = true;
    },
    addCarSuccess(){
      this.$refs.shopcar.getCarInfo();
    },
    closeAddressDialogHandle(){
      this.addressDialogShow = false;
    },
    addOrEditSuccess(){
      this.$refs.shopcar.getCarInfo();
      this.addressDialogShow = false;
    },
    exchangeSuccess(){
      this.sureOrderDialogShow = false;
      this.$refs.shopcar.getCarInfo();
      this.carDialogShow = false;
    },
    locationClick(){
      this.addressDialogShow = true;
    },
    acceptQuantity(num){
      // 购物车总数量同步
      this.carInfo.cartSize = this.carInfo.cartSize - 1;
    },
  }
};
</script>

<style lang="scss" scoped>
.integral-shop {

}
</style>
